import React from 'react';

const AboutUs = () =>
{

  //changeClass("mainbody");
  return (
    <div id="AboutUs">
      <div className="sectionTitle">About Us</div><br/>
      <div className="sectionText">
        <p>Flying Metal Aviation takes aircraft that need some attention and love in order to get back in the air again.</p>
        <p>It was formed by Roger Wyatt, Andrew Gordon, and Jamie Pinkham in 2022.</p>
        <p>If you have an aircraft that you need to sell - maybe you've lost your medical, maybe it needs more work than you can put into it, or whatever the reason -
        just contact us and let's talk about how we can help you. We don't just buy and sell airplanes, we help people with their aircraft.</p>
      </div>
    </div>
  )
};

export default AboutUs;